import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import styles from './table.css';

import { Deprecated, Download } from 'components';

import Translate from 'utils/translate';

class RowDetails extends Component {
  render() {
    let { row, expanded, toggleRow, index, display, background } = this.props;

    let fileSize = <Translate stringID="label.na" defaultValue="N/A" />;
    let releaseType = <Translate stringID="label.notAvailable" defaultValue="Not Available" />;
    let disabledKBlink = '';
    let disabledURL = '';

    /** Create URL text for the Download columns for disabled entries.
     * A disabled entry can have a boolean value of true or false, or a link to a KB article.
     * If 'row.disabled' is true, the KB article explaining the reason for the removal isn't yet
     * available, so no link to the KB is created. If 'row.disabled' contains a KB article link,
     * the KB article link text is stored in 'disabledKBlink' and the KB article URL is
     * stored in 'disabledURL' for insertion into the download column.
     */
    if (row.disabled) {
      if (row.disabled === true) {
        disabledKBlink = '';
      } else if (row.disabled && row.disabled.includes("http") === true) {
        disabledKBlink = 'KB ' + row.disabled.split("/").pop();
        disabledURL = row.disabled;
      }
    }

    if (row.fileSize) {
      fileSize = row.fileSize;
    }
    
    // Modify entries with 'GM' as the releaseType to show as GA (GM is an internal term).
    if (row.releaseReason) {
      if (row.releaseReason === "GM") {
        row.releaseReason = "GA";
      }
    }
    
    // Modify entries with 'GM' in the releaseName to show as GA (GM is an internal term).
    if (row.releaseName) {
      let re = /(.*?)(_GM)/;
      if (re.test(row.releaseName) === true) {
        row.releaseName = row.releaseName.replace(re, "$1_GA");
      }
    }

    const collapseCircle = (
      <img src={require('images/collapse-circle.svg')} width={14} height={14} />
    );
    
    const expandCircle = <img src={require('images/expand-circle.svg')} width={14} height={14} />;
    return (
      <tr style={{ display: display ? 'table-row' : 'none', background: background }}>
        <td style={{ width: 0, padding: '0px', paddingLeft: 15, borderRight: 'none' }}>
          <a
            href="#"
            onClick={() => toggleRow(index)}
            style={{ display: 'block', height: 14 }}
          >
            {expanded ? collapseCircle : expandCircle}
          </a>
        </td>
        <td style={{ borderLeft: 'none', paddingRight: 10 }}>
          <Download src={row.download} text={row.title} disabled={row.disabled} />
        </td>
        {row.releaseType || row.releaseType === '' ? <td styleName="center">{row.releaseType}</td>: null}
        {row.release || row.release === '' ? <td styleName="center">{row.release}</td>: null}
        {row.releaseReason || row.releaseReason === ''  ? <td styleName="center">{row.releaseReason}</td>: null}
        {row.releaseDate || row.releaseDate === '' ? <td styleName="center">{row.releaseDate}</td>: null}
        {(row.minimumDsmVersionRequired || row.minimumDsmVersionRequired === '') && row.product !== "Appliance" ? <td styleName="center">{row.minimumDsmVersionRequired}</td>: null}
        <td styleName="action">
          {row.disabled ? <a href={disabledURL}>{disabledKBlink}</a> : <Download src={row.download} displayIcon={true} />}
        </td>
      </tr>
    );
  }
}

RowDetails.propTypes = {
  background: PropTypes.string.isRequired,
  row: PropTypes.object.isRequired,
  expanded: PropTypes.bool.isRequired,
  display: PropTypes.bool.isRequired,
  toggleRow: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};

export default CSSModules(RowDetails, styles);
